<template>
    <section class="container-fluid">
      <div class="container d-flex flex-wrap">
        <div class="d-flex justify-content-center col-xl-2 col-lg-4 col-md-4 col-sm-6">
          <img src="../../../../assets/img/landing/microsoft.svg" alt="microsoft">
        </div>
        <div class="d-flex justify-content-center col-xl-2 col-lg-4 col-md-4 col-sm-6">
          <img src="../../../../assets/img/landing/dropbox.svg" alt="dropbox">
        </div>
        <div class="d-flex justify-content-center col-xl-2 col-lg-4 col-md-4 col-sm-6">
          <img src="../../../../assets/img/landing/hnm.svg" alt="hnm">
        </div>
        <div class="d-flex justify-content-center col-xl-2 col-lg-4 col-md-4 col-sm-6">
          <img src="../../../../assets/img/landing/airbnb.svg" alt="airbnb">
        </div>
        <div class="d-flex justify-content-center col-xl-2 col-lg-4 col-md-4 col-sm-6">
          <img src="../../../../assets/img/landing/canon.svg" alt="canon">
        </div>
        <div class="d-flex justify-content-center col-xl-2 col-lg-4 col-md-4 col-sm-6">
          <img src="../../../../assets/img/landing/dell.svg" alt="dell">
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'SectionTwo'
}
</script>

<style lang="scss" scoped>

.container-fluid {
  background-color: rgba(71, 58, 209, 0.06);
  padding: 90px 0;
}

</style>
